import "../../css/pageLayout.css"
import { parseJsonField } from "../../utils/parseJsonField";

function ListSection({ section }) {
  const settings = parseJsonField(section.settings_json);
  const items = section.items || [];

  const ListTag = settings.list_type === "ol" ? "ol" : "ul";

  return (
        <section className="list-section">
      {settings.title && <h3>{settings.title}</h3>}

      <ListTag className="list-items">
        {items
          .filter((item) => item.is_visible !== false)
          .map((item) => {
            const content = parseJsonField(item.content_json);

            return (
              <li key={item.id} className="list-item">
                {content.link ? (
                  <a href={content.link}>{content.text}</a>
                ) : (
                  content.text
                )}
              </li>
            );
          })}
      </ListTag>
    </section>
  );
}


export default ListSection;